import { render } from "./TicketStatusBadge.vue?vue&type=template&id=0badcf92"
import script from "./TicketStatusBadge.vue?vue&type=script&lang=js"
export * from "./TicketStatusBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__